import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const { carbon, blue } = colorsPalettes;

export const SeeAll = styled.span`
    visibility: hidden;
`;

export const TopKeywordsContainer = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 4px;
    ${setFontVariant("input2", carbon[400])};

    &:hover {
        ${SeeAll} {
            visibility: visible;
        }
    }
`;

export const TotalKeywords = styled.div`
    ${setFontVariant("input2", blue[400])};
    display: flex;
    gap: 4px;
    cursor: pointer;
    box-sizing: border-box;
`;
